export default "__VITE_ASSET__JIU2Xi9f__"